// Flash Messages JavaScript Utility
export const initializeFlashMessages = () => {
  console.log('Initializing flash messages...');
  const flashMessages = document.querySelectorAll('.flash-message');
  console.log(`Found ${flashMessages.length} flash messages`);

  flashMessages.forEach(function(message, index) {
    console.log(`Processing flash message ${index + 1}:`, message);

    // Auto-hide after 5 seconds
    setTimeout(function() {
      hideFlashMessage(message);
    }, 5000);

    // Handle close button click
    const closeButton = message.querySelector('.flash-message-close');
    console.log(`Close button for message ${index + 1}:`, closeButton);

    if (closeButton) {
      console.log('Binding close button event for flash message');

      // Remove any existing event listeners to prevent duplicates
      closeButton.removeEventListener('click', handleCloseClick);

      // Add new event listener
      closeButton.addEventListener('click', handleCloseClick);

      function handleCloseClick(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Close button clicked');
        hideFlashMessage(message);
      }
    } else {
      console.warn('No close button found in flash message');
    }
  });
};

export const hideFlashMessage = (message) => {
  console.log('Hiding flash message');
  if (message && message.parentNode) {
    message.classList.add('slide-up');
    setTimeout(() => {
      if (message.parentNode) {
        console.log('Removing flash message from DOM');
        message.remove();
      }
    }, 300);
  }
};

// Initialize immediately if DOM is already ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeFlashMessages);
} else {
  // DOM is already ready
  initializeFlashMessages();
}

// Note: Turbo event listeners removed as Turbo is disabled

// Re-initialize when new flash messages are added dynamically
export const reinitializeFlashMessages = () => {
  initializeFlashMessages();
};